/** Twilio Account SID: the prefix "AC" plus 32 hex characters. */
export const TWILIO_ACCOUNT_SID_PATTERN = /^AC[0-9a-fA-F]{32}$/;

export const TWILIO_INBOUND_WEBHOOK_URL_MAX_LENGTH = 2048;

/**
 * Empty is allowed. A non-empty value must be an absolute http(s) URL with
 * no embedded credentials. Parsed without the DOM `URL` type so this package
 * typechecks on the ES2020 lib.
 */
export function inboundWebhookUrlProblem(value: string): "invalid" | null {
  const trimmed = value.trim();
  if (trimmed.length === 0) return null;
  if (trimmed.length > TWILIO_INBOUND_WEBHOOK_URL_MAX_LENGTH) return "invalid";
  if (/\s/.test(trimmed)) return "invalid";

  const match = /^(https?):\/\/([^/?#]+)(.*)$/i.exec(trimmed);
  if (!match) return "invalid";
  const host = match[2];
  if (host.includes("@") || host.startsWith("[") || host.endsWith("]")) {
    return "invalid";
  }
  return webhookHostProblem(host);
}

/** A hostname plus an optional port in 1–65535. Empty labels and "." are rejected. */
function webhookHostProblem(hostport: string): "invalid" | null {
  const colon = hostport.lastIndexOf(":");
  const hostname = colon === -1 ? hostport : hostport.slice(0, colon);
  const portText = colon === -1 ? null : hostport.slice(colon + 1);
  if (portText !== null && !isWebhookPort(portText)) return "invalid";
  if (!isWebhookHostname(hostname)) return "invalid";
  return null;
}

function isWebhookPort(portText: string): boolean {
  if (!/^[1-9]\d{0,4}$/.test(portText)) return false;
  return Number(portText) <= 65535;
}

function isWebhookHostname(hostname: string): boolean {
  if (hostname.length === 0 || hostname.length > 253) return false;
  const labels = hostname.split(".");
  return labels.every((label) =>
    /^(?:[A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]{0,61}[A-Za-z0-9])$/.test(label),
  );
}
